import { HttpParams, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EnumEstadoBolsaCurso } from '../models/enumEstadoBolsaCurso';
import { BolsaInstituicaoCursoListItemDTO } from '../models/bolsaInstituicaoCursoListItemDTO';
import { BolsaInstituicaoCursoListItemDTOICollectionPagedResponse } from '../models/bolsaInstituicaoCursoListItemDTOICollectionPagedResponse';
interface BolsaInstituicaoCurso {
  id: string;
  nome: string;
  descricao: string;
}
@Injectable({
  providedIn: 'root'
})
export class BolsaInstituicaoCursoService {
  private readonly path = 'bolsa';
  public params = new HttpParams();

  constructor(private apiService: ApiService) {}

  // List all BolsaInstituicaoCurso
  list(params?: any): Observable<any> {
    console.log('params', params);
    return this.apiService.get<{ data: BolsaInstituicaoCurso[] }>(`${this.path}/getAllBolsaInstituicaoCurso`, params ? new HttpParams({
      fromObject: params
    }) : this.params).pipe(
      map(response => response)
    );
  }

  // Get BolsaInstituicaoCurso by ID
  public show(id: string): Observable<BolsaInstituicaoCurso> {
    return this.apiService.get<{ data: BolsaInstituicaoCurso }>(`${this.path}/getBolsaInstituicaoCursoById/${id}`).pipe(
      map(response => response.data)
    );
  }

  // Create new BolsaInstituicaoCurso
  public store(bolsaInstituicaoCurso: any): Observable<any> {
    return this.apiService
      .post<any>(`${this.path}/AddBolsaInstituicaoCurso`, bolsaInstituicaoCurso)
      .pipe(
        map(response => response)
      );
  }

  // Update existing BolsaInstituicaoCurso
  public update(bolsaInstituicaoCurso: any): Observable<any> {
    return this.apiService
      .put<any>(`${this.path}/UpdateBolsaInstituicaoCurso`, bolsaInstituicaoCurso)
      .pipe(
        map(response => response)
      );
  }

  // Delete existing BolsaInstituicaoCurso
  public delete(id: string): Observable<any> {
    return this.apiService.delete(`${this.path}/DeleteBolsaInstituicaoCursoById/${id}`);
  }

  public getAllBolsaInstituicaoCursoGet(pageNumber?: number, pageSize?: number, orderBy?: string, bolsaID?: number, instituicaoEnsinoCursoID?: number, dataInicio?: string, dataFim?: string, aproveitamento?: EnumEstadoBolsaCurso, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<BolsaInstituicaoCursoListItemDTOICollectionPagedResponse> {
    const params = new HttpParams()
      .set('pageNumber', pageNumber?.toString() || '')
      .set('pageSize', pageSize?.toString() || '')
      .set('orderBy', orderBy || '')
      .set('bolsaID', bolsaID?.toString() || '')
      .set('instituicaoEnsinoCursoID', instituicaoEnsinoCursoID?.toString() || '')
      .set('dataInicio', dataInicio || '')
      .set('dataFim', dataFim || '')
      .set('aproveitamento', aproveitamento?.toString() || '');

    return this.apiService.get<BolsaInstituicaoCursoListItemDTOICollectionPagedResponse>(`${this.path}/GetAllBolsaInstituicaoCurso`, params);
  }
}
